import type { Empresa } from './empresa.model';

export interface EmpresaStats extends Empresa {
  total_telas:   number;
  telas_online:  number;
}

export interface TelemetriaHw {
  cpu_pct:        number;
  ram_total_mb:   number;
  ram_livre_mb:   number;
  disco_total_gb: number;
  disco_livre_gb: number;
  uptime_min:     number;
  app_version:    string;
  ts:             string;
}

export interface HeartbeatLog {
  tela_id:        string;
  tela_nome:      string;
  empresa_nome:   string;
  status:         string;
  ultima_conexao: string | null;
  log:            string | null;
  telemetria_hw:  TelemetriaHw | null;
}

export interface TelaGlobal {
  id:             string;
  nome:           string;
  localizacao:    string | null;
  status:         'online' | 'offline';
  layout_atual:   'fullscreen' | 'l-bar';
  ultima_conexao: string | null;
  watchdog_log:   unknown;
  empresa_id:     string;
  empresa_nome:   string;
  revogada:       boolean;
}

export interface MetricasLicencas {
  licencasTotais:  number;
  telasOnline:     number;
  telasOffline:    number;
  alertasWatchdog: number;
}

export interface TokenAtivacao {
  id:          string;
  empresa_id:  string;
  token:       string;
  usado:       boolean;
  tela_id:     string | null;
  criado_em:   string;
  expira_em:   string;
  ativado_em:  string | null;
}

export interface WatchdogLogEntry {
  id:           string;
  empresa_id:   string | null;
  tela_id:      string | null;
  tela_nome:    string | null;
  empresa_nome: string | null;
  tipo:         string;
  acao:         string;
  midia_id:     string | null;
  criado_em:    string;
}

export interface TenantUser {
  user_id:   string;
  email:     string;
  role:      string;
  criado_em: string;
}

export interface GrupoTela {
  id:          string;
  nome:        string;
  descricao:   string | null;
  criado_em:   string;
  total_telas: number;
}

export type StatusAuditoria = 'concluido' | 'pendente' | 'falhou';
export type OrigemAuditoria = 'rpc' | 'edge' | 'trigger';

export interface RegistroAuditoria {
  id:         string;
  criado_em:  string;
  ator_id:    string | null;
  ator_email: string | null;
  acao:       string;
  empresa_id: string | null;
  tela_id:    string | null;
  detalhes:   Record<string, unknown>;
  origem:     OrigemAuditoria;
  status:     StatusAuditoria;
}

/** `de` inclusivo e `ate` exclusivo, em ISO 8601. `acao` filtra por prefixo. */
export interface FiltrosAuditoria {
  empresaId?: string;
  acao?:      string;
  status?:    StatusAuditoria;
  de?:        string;
  ate?:       string;
}

export interface PaginaAuditoria {
  registros: RegistroAuditoria[];
  temMais:   boolean;
}

export const TAMANHO_PAGINA_AUDITORIA = 50;

export interface PlaylistResumo {
  id:          string;
  nome:        string;
  total_itens: number;
}

export interface ResultadoClonePlaylist {
  playlist_id:     string;
  nome:            string;
  itens_copiados:  number;
  itens_ignorados: number;
}

export interface ResultadoLote {
  total:   number;
  online:  number;
  offline: number;
}

export type EstiloAviso = 'modal' | 'ticker';

export type RecursoLote =
  | 'exibir_futebol' | 'exibir_bolao' | 'exibir_raiox_musica' | 'exibir_resultado_eleicao'
  | 'exibir_pdv_engajamento' | 'qrcode_jukebox' | 'config_tema_copa' | 'config_tema_festa_junina'
  | 'config_tema_dia_namorados';

export type AlteracoesRecursos = Partial<Record<RecursoLote, boolean>>;

export const MODULOS_PLATAFORMA = [
  'jukebox', 'futebol', 'pdv', 'identidade_sonora', 'whatsapp', 'anunciantes',
] as const;

export type ModuloPlataforma = (typeof MODULOS_PLATAFORMA)[number];

export const ROTULO_MODULO: Record<ModuloPlataforma, string> = {
  jukebox:            'Jukebox',
  futebol:            'Futebol',
  pdv:                'PDV/Chopp',
  identidade_sonora:  'Identidade Sonora',
  whatsapp:           'WhatsApp',
  anunciantes:        'Anunciantes',
};

export interface ExcecaoModulo {
  modulo:    ModuloPlataforma;
  liberado:  boolean;
  motivo:    string;
  criado_em: string;
}

export type TipoAlerta = 'tela_offline' | 'integracao_erro' | 'tela_travando';

export interface Alerta {
  id:            string;
  tipo:          TipoAlerta;
  empresa_id:    string | null;
  tela_id:       string | null;
  aberto_em:     string;
  resolvido_em:  string | null;
  resolvido_por: string | null;
  detalhes:      Record<string, unknown>;
}

export interface AlertasConfig {
  offline_min:           number;
  janela_inicio:         string;
  janela_fim:            string;
  pdv_erro_min:          number;
  watchdog_reinicios:    number;
  watchdog_janela_min:   number;
}
